import { Box, Container, Stack, VStack } from "@chakra-ui/react";
import useSite from "../../hooks/use-site";
import dynamic from "next/dynamic";

const Newsletter = dynamic(() => import("./components/Newsletter"));
const FooterMenu = dynamic(() => import("./components/FooterMenu"));
const SocialMedia = dynamic(() => import("./components/SocialMedia"));
const Footer = () => {
  const { getMenuByName, page } = useSite();

  const shouldHideFooterForm = page?.pageSettings?.hideFooterForm;

  const menuLocations = ["footer1", "footer2", "footer3", "footer4"];
  const menus = [];

  menuLocations.map((loc) => menus.push(getMenuByName(loc)));
  return (
    <Box>
      {!shouldHideFooterForm && <Newsletter />}
      <Container py={12}>
        <VStack align="stretch" gap={4}>
          <Stack
            direction={{ base: "column", md: "row" }}
            justify="center"
            gap={8}
            textAlign="center"
          >
            {menus.map((menu, i) => (
              <Box key={i} flex="1">
                <FooterMenu {...menu} />
              </Box>
            ))}
          </Stack>
          <SocialMedia />
        </VStack>
      </Container>
    </Box>
  );
};

export default Footer;
